import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2'
import { ReportsRoutes } from './reports.routing'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { RouterModule } from '@angular/router'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { SharedModule } from '../../shared/shared.module'
import { ReportsComponent } from './reports.component'
import { RdnReportsComponent } from './rdn-reports/rdn-reports.component'
import { CommercialLicenseReportsComponent } from './commercial-license-reports/commercial-license-reports.component'
import { RateBookReportsComponent } from './rate-book-reports/rate-book-reports.component'
import { BusinessBookReportsComponent } from './business-book-reports/business-book-reports.component'
import { PropertyRatesDefaultersComponent } from './property-rates-defaulters/property-rates-defaulters.component'
import { BusinessLicenceDefaultersComponent } from './business-licence-defaulters/business-licence-defaulters.component'

@NgModule({
  declarations: [
    ReportsComponent,
    RdnReportsComponent,
    CommercialLicenseReportsComponent,
    RateBookReportsComponent,
    BusinessBookReportsComponent,
    PropertyRatesDefaultersComponent,
    BusinessLicenceDefaultersComponent,
  ],
  imports: [
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    SweetAlert2Module.forRoot(),
    RouterModule.forRoot(ReportsRoutes, {
      scrollPositionRestoration: 'top',
    }),
    HttpClientModule,
    SharedModule,
  ],
  exports: [
    ReportsComponent,
    RdnReportsComponent,
    CommercialLicenseReportsComponent,
    RateBookReportsComponent,
    BusinessBookReportsComponent,
  ],
})
export class ReportsModule {}
